import React, { useEffect } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import * as modalDataService from './modalDataService';
import * as validationService from "./validationService";

function MSClientIdField({ msClientId, error, disabled }) {

    //const [disableValue, setDisableValue] = useState(disabled)

    useEffect(() => {
        validationService.validateNotEmpty(msClientId, 'msClientId');
        return () => validationService.cleanValidation('msClientId');
    }, [msClientId])

    // useEffect(() => {        
    //         setDisableValue(false);
    // }, [])

    const onChange = (value) => modalDataService.changeMSClientId(value);

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="ms_clientid">Client Id <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="ms_clientid-key"
                    disabled={disabled}
                    value={msClientId}
                    onChange={event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("MSClientIdField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    return {
        msClientId: addDeviceModal.msClientId || '',
        error: validation.msClientId,
    }
}

export default connect(mapStateToProps)(MSClientIdField);
